import { Injectable, Inject, Output, EventEmitter } from '@angular/core';
import _ from 'lodash';
import { ApiService } from 'app/services/api.service';
import { Observable } from 'rxjs/Observable';
import { CrncyRateModel, CostItemModel } from './index';
import { Subscription } from 'rxjs';



export class ExchangeModel {
  orgCrncyRate: CrncyRateModel;
  targetCrncyRate: CrncyRateModel;
  changedCost: number;
}

@Injectable()
export class CommonService {
  constructor(){}

  @Output() headerSortedEmit: EventEmitter<any> = new EventEmitter();
  @Output() clearHeaderEmit: EventEmitter<any> = new EventEmitter();
  

  headerClick(header:TableHeader, data:any, headerList?:Array<TableHeader>, type?:number){
    if(!header.isUseEvent || data == null) return;
    
    if(header.orderBy.indexOf("ASC") > -1){
        header.orderBy = 'DESC';
    }else{
        header.orderBy = 'ASC';
    }
    let columnNm:string = header.columnNm;
    data = _.map(data, 
      (item:any) =>{
        if(item.columnNm == null || item.columnNm == undefined){
          item.columnNm = '';
        }
        return item;
      }
    );
    data = _.orderBy(data, [columnNm], [_.lowerCase(header.orderBy)]);

    if(type != null && type != undefined){
      this.headerSortedEmit.emit({data:data, type:type});
    }else{  
      this.headerSortedEmit.emit(data);
    }

    if(headerList != null && headerList.length > 0){
      headerList = _.map(headerList, 
        (h:TableHeader) => {
          if(h.columnNm != header.columnNm){
            h.orderBy = 'ASC';
          }
          return h;
        }
      );

      if(type != null && type != undefined){
        this.clearHeaderEmit.emit({headerList:headerList, type:type});
      }else{  
        this.clearHeaderEmit.emit(headerList);
      }
    }
  }

  clearOrderByHeader(headerList:Array<TableHeader>, type?:number){
    if(headerList == null) return;

    for(let header of headerList){
      header.orderBy = 'ASC';
    }
    
    if(type != null && type != undefined){
      this.clearHeaderEmit.emit({headerList:headerList, type:type});
    }else{  
      this.clearHeaderEmit.emit(headerList);
    }
  }
}

@Injectable()
export class CurrencyService {
  @Output() currencyListEe: EventEmitter<CrncyRateModel[]> = new EventEmitter();
  
  currencyList: CrncyRateModel[] = [];

  constructor(private apiService: ApiService) {
    this.getCrncyList();
  }

  getExchange(orgCrncyCd: string, targetCrncyCd: string, cost: number, callback?: (value: ExchangeModel) => void): Subscription {
    if (!orgCrncyCd || !targetCrncyCd || !cost) return;

    return this.apiService.get('exchange', {orgCrncyCd: orgCrncyCd, targetCrncyCd: targetCrncyCd, cost: cost}).subscribe(
      resp => {
        if (resp && callback) callback(resp.data);
      }
    );
  }

  getCrncyList(){
    if(this.currencyList == null || this.currencyList.length < 1){
      this.apiService.get('crncyRate').subscribe(
        res => {
          if(res.result){
            this.currencyList = res.data;
            return this.currencyListEe.emit(this.currencyList);
          }
        }
      );
    }else{
      return this.currencyListEe.emit(this.currencyList);
    }
  }

  getCrncyListSort(cntryCdList:Array<string>, callback?: (value: CrncyRateModel[]) => void): Subscription {
    return this.apiService.get('crncyMap', cntryCdList).subscribe(
      res => {
        if(res && callback) callback(res.data);
      }
    )
  }
}

@Injectable()
export class CostItemService {
  @Output() costItemEe: EventEmitter<CostItemModel[]> = new EventEmitter();
  costItemList: Array<CostItemModel> = [];

  constructor(private apiService: ApiService){
    this.getCostItemList();
  }

  getCostItemList(){
    if(this.costItemList == null || this.costItemList.length < 1){
      this.apiService.get('costitem').subscribe(
        res => {
          if(res.result){
            this.costItemList = res.data;
            return this.costItemEe.emit(this.costItemList);
          }
        }
      );
    }else{
      return this.costItemEe.emit(this.costItemList);
    }
  }
}

@Injectable()
export class CodeService {
  codeList: Array<CodeSubModel> = [];

  constructor(private apiService: ApiService){

  }

  getCodeListByCodeId(id:any){
    return this.apiService.get('codes/' + id);
  }
}

export class CodeSubModel {
  cdId:number;
  cdSeq:number;
  cdNm:string;
  cdDescr:string;
}


export class TableHeader {
    columnNm:string;
    columnText:string;
    index:number;
    orderBy:string;
    isUseEvent:boolean;

    constructor(index, columnNm, columnText, isUseEvent){
        this.columnNm = columnNm;
        this.columnText = columnText;
        this.index = index;
        this.orderBy = "ASC";
        this.isUseEvent = isUseEvent;
    }

}


// WEBPACK FOOTER //
// ./src/app/services/common.service.ts